import { Flex, Progress } from '@mantine/core';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import {
	TotalVestingAllocationStyles,
	VESTING_ALLOCATION_COLORS,
} from '@dealstack/frontend/shared/components/VestingTerms/TotalVestingAllocation/TotalVestingAllocation.styles.tsx';
import { VestingAllocationLegend } from '@dealstack/frontend/shared/components/VestingTerms/TotalVestingAllocation/VestingAllocationLegend.tsx';
import { VestingCard } from '@dealstack/frontend/shared/components/VestingCard/VestingCard.tsx';

interface Props {
	timeBasedPercentage: number;
	performancePercentage: number;
}

export const TotalVestingAllocation = ({ timeBasedPercentage, performancePercentage }: Props) => {
	const tMipManage = useTranslationMipManage();

	const unvestedPercentage = Math.max(
		0,
		+(100 - timeBasedPercentage - performancePercentage).toFixed(2)
	);

	return (
		<TotalVestingAllocationStyles>
			<VestingCard
				title={tMipManage('total_vesting_allocation.title')}
				titleSize="md"
				titleWeight={600}
				titleColor="dark.8"
			>
				<Progress.Root size="md" mt="0.75rem" mb="0.5rem">
					<Progress.Section
						value={timeBasedPercentage}
						color={VESTING_ALLOCATION_COLORS.timeBased}
					/>
					<Progress.Section
						value={performancePercentage}
						color={VESTING_ALLOCATION_COLORS.performance}
					/>
					<Progress.Section
						value={unvestedPercentage}
						color={VESTING_ALLOCATION_COLORS.unvested}
					/>
				</Progress.Root>

				<Flex justify="space-between" align="center" className="legend">
					<VestingAllocationLegend
						color={VESTING_ALLOCATION_COLORS.timeBased}
						label={tMipManage('total_vesting_allocation.legend.time_based', {
							percentage: timeBasedPercentage,
						})}
					/>

					<VestingAllocationLegend
						color={VESTING_ALLOCATION_COLORS.performance}
						label={tMipManage('total_vesting_allocation.legend.performance', {
							percentage: performancePercentage,
						})}
					/>

					<VestingAllocationLegend
						color={VESTING_ALLOCATION_COLORS.unvested}
						label={tMipManage('total_vesting_allocation.legend.unvested', {
							percentage: unvestedPercentage,
						})}
					/>
				</Flex>
			</VestingCard>
		</TotalVestingAllocationStyles>
	);
};
